import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CategoryWidget = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('http://localhost:5000/api/categories'); // Adjust the URL as needed
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="widget">
      <div className="widget--title">
        <h2 className="h4">categories</h2>
        <i className="icon fa fa-folder-open-o" />
      </div>
      {/* Nav Widget Start */}
      <div className="nav--widget">
        <ul className="nav">
          {categories.map((category) => (
            <li key={category.id}>
              <a href="#">
               <span>[ {category.Name} ]</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
      {/* Nav Widget End */}
    </div>
  );
};

export default CategoryWidget;